<header class="header">
  <div class="virsaLogo">
    <a routerLink="/international-class">
      <img
        loading="lazy"
        class="virsa_Logo"
        src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/virsa-white-logo.png"
        alt="virsa logo"
      />
    </a>
  </div>

  <!-- NAVIGATION LINKS -->
  <ul class="nav_link_list">
    <li class="nav_item" routerLinkActive="active">
      <button mat-button class="header-link" routerLink="/international-class">
        Home
      </button>
    </li>
  </ul>

  <!-- RIGHT SIDE MENU -->

  <li class="nav_item" *ngIf="userSignedIn">
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      aria-label="User Menu"
    >
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="user-info">
        <div>
          Name: {{ Cap(data.user.first_name + " " + data.user.last_name) }}
        </div>
        <div>Id: {{ data.virsa_id }}</div>
      </div>

      <mat-divider></mat-divider>

      <button mat-menu-item routerLink="/international-class/my-virsa">
        <mat-icon>person</mat-icon><span>My Account</span>
      </button>

      <mat-divider></mat-divider>

      <button mat-menu-item (click)="signOut()">
        <span>Sign Out</span>
      </button>
    </mat-menu>
  </li>
</header>
